




















import Vue from 'vue'
import MapMarkerList from '@/components/MapMarkerList.vue'
import GoogleMap from '@/components/app/GoogleMap.vue'

export default Vue.extend({
  components: { GoogleMap, MapMarkerList },
  props: {
    map: {
      type: Object,
      default: () => {
        return {
          _id: "",
          settings: {
            center: {
              lat: 53,
              lng: -1
            },
            zoom: 6
          },
          title: "Map"
        }
      }
    },
    markers: {
      type: Array as () => Array<MapItem>
    }
  },
  data() {
    return {
      activeMarker: -1,
      infoWindowOpen: false
    }
  },

  computed: {
    
  },

  methods: {
    infoClick() {
      this.$emit('markerInfoClick', this.activeMarker)
    },
    selectMarker(marker, index) {
      if (index > -1) {
        this.$set(this.map, "settings", {center: marker.position, zoom: 15})
        this.infoWindowOpen = true
        this.activeMarker = index
      } else {
        this.infoWindowOpen = false
        this.activeMarker = -1
      }
    }
  }
})
